$(".ourExpertStickyButton").on("click", function (e) {
  e.preventDefault();
  let gotoElem = $($(this).attr("href"));
  if (gotoElem.length > 0) {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: gotoElem.offset().top - 180,
      },
      1000
    );
  }
});
var oldScrollTop = $(window).scrollTop();
$(window).scroll(function () {
  if(oldScrollTop == 0) {
    oldScrollTop = $(this).scrollTop();
    $(".ourExpertStickyWrapper").removeClass("low");
  } else {
    if(oldScrollTop > $(this).scrollTop()) {
      console.log(oldScrollTop, $(this).scrollTop());
      $(".ourExpertStickyWrapper").addClass("low");
    } else {
      $(".ourExpertStickyWrapper").removeClass("low");
    }
    oldScrollTop = $(this).scrollTop();
  }
});